import React from 'react';
import Main from './app/Main';

function App() {
  return (
    <Main />
  );
}

export default App;
